import { z } from 'zod';
import { UUIDSchema } from './common';
export const ScriptAutomationTypeSchema = z.enum(['single_deals', 'fund_deals', 'saas_deals', 'clickup_to_hubspot']);
export const ScriptAutomationTaskCreationResponseSchema = z.object({ data: z.string() });
export const ScriptAutomationLogSchema = z.object({
    task_id: UUIDSchema,
    isFinished: z.boolean(),
    task_output: z.string(),
    execution_timestamp: z.string(),
});
const ScriptAutomationTaskLogsResponseShape = {
    logs: ScriptAutomationLogSchema.array(),
};
export const ScriptAutomationTaskLogsResponseSchema = z.object(ScriptAutomationTaskLogsResponseShape);
